export default __webpack_public_path__ + "static/media/ad-img.a510ecca.png";